/* global __APP_CONFIG__ */
const appConfig = typeof __APP_CONFIG__ !== 'undefined' ? __APP_CONFIG__ : {};

module.exports = {
    API_HOST: appConfig.VUE_APP_API_HOST,
    INSIGHT_HOST: appConfig.VUE_APP_INSIGHT_HOST,
    VUE_APP_PUBLIC_INSIGHT_API_HOST: appConfig.VUE_APP_PUBLIC_INSIGHT_API_HOST,
    VUE_APP_PUBLIC_INSIGHT_ACCESS_TOKEN: appConfig.VUE_APP_PUBLIC_INSIGHT_ACCESS_TOKEN,
    VUE_APP_ACCESS_TOKEN: appConfig.VUE_APP_ACCESS_TOKEN,
    VUE_APP_I18N_LOCALE: appConfig.VUE_APP_I18N_LOCALE,
    VUE_APP_I18N_FALLBACK_LOCALE: appConfig.VUE_APP_I18N_FALLBACK_LOCALE,
    BODHI_HOST: appConfig.VUE_APP_BODHI_HOST,
    CRAWLER_HOST: appConfig.VUE_APP_CRAWLER_HOST,
    CLIPPER_HOST: appConfig.VUE_APP_CLIPPER_HOST,
    CLIPPER_HOST_NEW: appConfig.VUE_APP_CLIPPER_HOST_NEW,
    AM5_CHART_LICENSE_KEY: appConfig.VUE_APP_AM5_CHART_LICENSE_KEY,
    AM5_CHART_LICENSE_MAP_KEY: appConfig.VUE_APP_AM5_CHART_LICENSE_MAP_KEY,
    ENVIRONMENT: appConfig.environment,
    // Fallback only. The sign-in flow uses the codeLength the API reports, so
    // this is what the code input falls back to before that value arrives.
    MFA_CODE_LENGTH: 6,
    // Fallback only, same as above: the API reports resendCooldownSeconds and
    // is what actually enforces the wait.
    MFA_RESEND_COOLDOWN_SECONDS: 30,
};
